import * as React from 'react'
import { HashFields, HiddenField, Label } from 'react-rails-form-helpers'
import * as API from '../lib/api'
import { UnifiedCardInput } from './UnifiedCardInput'

interface IProps {
  creditCard?: API.ICreditCard
  handleCancelAddNewCardClick: () => void
  allowCancelling: boolean
}

export class UnifiedCreditCardForm extends React.Component<IProps, object> {
  public static defaultProps: IProps = {
    handleCancelAddNewCardClick: () => undefined,
    allowCancelling: false,
    creditCard: {
      card_number: '',
      cvv: '',
      exp_month: '',
      exp_year: '',
      first_name: '',
      last_name: '',
    },
  }

  public render() {
    const { creditCard, allowCancelling, handleCancelAddNewCardClick } = this.props

    if (!creditCard) {
      return null
    }

    return (
      <>
        <HashFields name={`credit_card`}>
          <div className="grid-x">
            <div className="cell small-full">
              <Label htmlFor="card_number_display">Credit/Debit Card</Label>
              <UnifiedCardInput
                defaultValues={{
                  cardNumber: creditCard.card_number,
                  cvv: creditCard.cvv,
                  expMonth: creditCard.exp_month,
                  expYear: creditCard.exp_year,
                }}
              />
              {
                allowCancelling ?
                  <Label className="field-bottom-label" htmlFor="card_number_display">
                    <a onClick={() => handleCancelAddNewCardClick()}>&larr; Back to a saved payment method.</a>
                  </Label> :
                  null
              }
            </div>
          </div>
        </HashFields>

        <HiddenField name="payment_type" value="credit_card" />

      </>
    )
  }
}
